<div class="d-flex" data-testid="wrapper">
  <button data-testid="left-trigger" mat-icon-button (click)="openLeft()">
    <am-icon name="menu"></am-icon>
  </button>
  <div class="spacer"></div>
  <button
    mat-icon-button
    data-testid="right-trigger"
    (click)="openRight()"
    *ngIf="rightContent"
  >
    <am-icon name="menu"></am-icon>
  </button>
</div>

<ng-content></ng-content>
